import React from "react";
import { Section } from "../components/elements/Section";
import { Icon } from "../components/elements";

export function Footer() {
  return (
    <Section as="footer" className="mc-footer">
      © All Rights Reserved by ♥ CoWallet | <Icon style={{ fontSize: "10px" }}>sell</Icon> {__APP_VERSION__}
    </Section>
  );
}
